import { Tooltip, TooltipProps } from '@mui/material'

export interface MolsonTooltipProps extends TooltipProps {
  dataTestId?: string
}

export const MolsonTooltip = ({
  dataTestId,
  children,
  ...props
}: MolsonTooltipProps) => {
  return (
    <Tooltip {...props}>
      <div>{children}</div>
    </Tooltip>
  )
}
